import { elementStylesMap, LINE_HEIGHT_AUTO_DIFF_VALUE } from '../constants/element-customization';
import { getComputedValue } from './get-default-elements-styles-values';
import lineHeightMap from '../../extensions/registry/ws-text-formatting/constants/line-height-map';

const getBasicLineHeightValues = (variables) => {
  const result = {};

  Object.entries(variables).forEach(([key, value]) => {
    if (key.endsWith(elementStylesMap.LINE_HEIGHT)) {
      const computedValue = getComputedValue(key, value);

      if (Object.values(lineHeightMap).includes(computedValue)) {
        // we need to add a small value to prevent matching with default options in line height select
        // for line heights that are equal to "Auto" option value and trigger "Custom" option instead
        result[key] = String(+computedValue + LINE_HEIGHT_AUTO_DIFF_VALUE);
      } else {
        result[key] = computedValue;
      }
    }
  });

  return result;
};

export default getBasicLineHeightValues;
